module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAfklEQVR4AWOgCzjGLUckopuG/0fA6CjD3yNMn3cz/z0EZINEMBEEQFX/OspwbRrb0jiJ6/P4foFE8Gs4zvBhu/CaWImJUXHH5+a93sALFCGg4dUm2c2lKv2e6nvLLZ9vlAaKEHDSx/3cT7bwP1oi/GQt74cDPNicNCjjYVACAFvwxSMEQtJpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ES.png
// module id = 1133
// module chunks = 0